import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './Pages/Home'
import Header from './Pages/Header'
const App = () => {
  return (
    <BrowserRouter>
        <Header />
      <div>
      <Routes>
          <Route path="/" element={<Home/>} />
          {/* <Route path="/contact" element={<Contact />} /> */}
          {/* <Route path="/product" element={<Product />} /> */}
        </Routes>
        
      </div>
    {/* <Footer /> */}

    </BrowserRouter>
  )
}
export default App;
